import { Box, Container, Text } from '@chakra-ui/react';

const Footer = () => {
  return (
    <Box as="footer" bg="gray.50" py={4} mt="auto">
      <Container maxW="container.xl">
        <Text textAlign="center" color="gray.600"> 
          formacioncontinua@castrobarros.edu.ar / 
          Esta web fue creada 100% con Inteligencia Artificial y no tiene fines de lucro. 
          © 2025 ISFD "DR. PEDRO IGNACIO DE CASTRO BARROS".
        </Text>
      </Container>
    </Box>
  );
};

export default Footer;